import { useMemo } from 'react'
import { notFuzzyMatch } from '@/utils/fuzzyMatch'
import helpDesk from '@/data/helpDesk.json'

export interface HelpArticle {
    key: string
    title: string
    url: string
    summary: string
}

export const getFaqSuggestions = (query: string): HelpArticle[] => {
    let out = notFuzzyMatch(helpDesk, ['title', 'summary'], query)
        .map((m) => m.item)
        .slice(0, 3);
    if (out.length < 3) {
        // fill with more articles if available
        const remaining = helpDesk.filter((item: HelpArticle) => !out.some((outItem) => outItem.key === item.key))
        const additional = remaining.slice(0, 3 - out.length)
        out = out.concat(additional)
    }
    return out
}

export const useFaqSuggestions = (query: string): HelpArticle[] => {
    return useMemo(() => getFaqSuggestions(query), [query])
}
